import Vue from 'vue';
import orderProductTransformer from './../../transformers/orderProduct';
import all from './all';

const success = (data, id, resolve) => {
  all(id);
  resolve(data);
};

const failed = (errors, reject) => {
  if (errors.error && errors.error.code) {
    reject(errors.error);
    return;
  }
  reject(orderProductTransformer.fetch(errors));
};

export default (id, orderProduct) => (
  new Promise((resolve, reject) => {
    Vue.$http
    .post(`/orders/${id}/products`, orderProductTransformer.send(orderProduct))
    .then((response) => {
      success(response.data, id, resolve);
    })
    .catch((error) => {
      failed(error.response.data, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/orderProduct/store.js